module.exports = __webpack_public_path__ + "static/media/CHRI_Gradient_DarkBlue_LightBlue_RGB.673f9fd2.png";